import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap, map } from 'rxjs/operators';

import { TrafficHistoryService } from '@ruby/core/http/car-traffic/traffic-history.service';
import * as CarTrafficActions from '@ruby/modules/car-traffic/store/actions/car-traffic.actions';
import { ICarTrafficSummary } from '@ruby/shared/models/car-traffic/car-traffic.interface';
import { IError } from '@ruby/shared/models/request/error.interface';

@Injectable()
export class CarTrafficEffects {
  getTrafficHistory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CarTrafficActions.loadTrafficHistory),
      mergeMap(action =>
        this.trafficHistoryService.get3YearsTrafficHistory(action.data).pipe(
          map((data: Array<ICarTrafficSummary>) => CarTrafficActions.loadTrafficHistorySuccess({ data })),
          catchError((error: IError) => of(CarTrafficActions.loadTrafficHistoryFailure({ error })))
        )
      )
    )
  );

  constructor(private actions$: Actions, private trafficHistoryService: TrafficHistoryService) {
  }
}
